import { ad2bs as e } from "../../../calendar-carburettor/converter/index.js";
import { isDateInConversionRange as t } from "../../../calendar-carburettor/is-date-in-conversion-range/index.js";
import "dayjs";
import "nepali-number";
// src/design/forms/datepicker/core/models/selectors/index.tsx
var n = (e) => e.events, r = (e) => e.ctx, i = (e, n) => !(!e.ctx.isNepali || t(n ? n(e.ctx.calendarReferenceDate) : e.ctx.calendarReferenceDate, !1)), a = (t) => {
	let { calendarReferenceDate: n, isNepali: i } = r(t);
	if (i) {
		let [t] = e(n).split("-");
		return t;
	}
	let [a] = n.split("-");
	return a;
};
export { i as disableAfterMaxEngDate, r as selectCtx, n as selectEvents, a as selectMonthViewYearLabel };

//# sourceMappingURL=index.js.map